import { embedUrl } from "@/routes/promo";
import { PlayCircleIcon, PlayIcon } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence, scale } from "framer-motion";

export function VideoDemo() {
  const [isPlaying, setIsPlaying] = useState(false);

  const startVideo = () => {
    setIsPlaying(true);
  };

  return (
    <motion.div
      className="flex-grow mt-5 relative w-full max-w-4xl aspect-video"
      initial={{ scale: 0.95, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <AnimatePresence mode="wait">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          {/* @ts-ignore */}
          {/* <wistia-player
            style={{
              background:
                "center / contain no-repeat url('https://fast.wistia.com/embed/medias/qfnfvx33qt/swatch'); display: block; filter: blur(5px); padding-top:52.71%;",
              width: "100%",
              height: "100%",
              position: "absolute",
              padding: 0,
              margin: 0,
              top: 0,
              left: 0,
            }}
            media-id="qfnfvx33qt"
            aspect="1.8972332015810276"
          /> */}

          <div
            className="wistia_responsive_padding overflow-hidden border border-gray-700 mx-auto aspect-video rounded-xl shadow-lg bg-black"
          >
            <div
              className="wistia_responsive_wrapper overflow-hidden"
              style={{
                height: "100%",
                left: 0,
                position: "absolute",
                top: 0,
                width: "100%",
                overflow: "hidden",
              }}
            >
              <iframe
                src="https://fast.wistia.net/embed/iframe/qfnfvx33qt?web_component=true&seo=true"
                title="BoostedPins: Grow your Shopify Store on Pinterest ❤️ Video"
                allow="autoplay; fullscreen"
                // allowTransparency={true}
                className="wistia_embed"
                name="wistia_embed"
                width="100%"
                height="100%"
                style={{
                  overflow: "hidden",
                }}
              ></iframe>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
}
